<template>
    <div v-if="nextSevenDays.length && lang != null" class="opening-hours__calendar">
        <span class="opening-hours__prev-week" :class="(minDateHit ? 'opening-hours__prev-week--disabled' : '')" @click="prevWeek()">
            <svgInline name="arrow" />
        </span>
        <div class="opening-hours__days">
            <div v-for="(day, index) in nextSevenDays" :key="index" class="opening-hours__day" v-bind="index">
                <span class="opening-hours__day-name">{{ getDayName(day.jsDate) }}</span>
                <template v-if="lang == 'en'">
                    <span class="opening-hours__month">{{ getMonth(day.jsDate) }}</span>
                    <span class="opening-hours__date">{{ getDate(day.jsDate) }}</span>
                </template>
                <template v-if="lang == 'da'">
                    <span class="opening-hours__date">{{ getDate(day.jsDate) }}</span>
                    <span class="opening-hours__month">{{ getMonth(day.jsDate) }}</span>
                </template>
                <template v-if="lang == 'de'">
                    <span class="opening-hours__date">{{ getDate(day.jsDate) }}</span>
                    <span class="opening-hours__month">{{ getMonth(day.jsDate) }}</span>
                </template>
                <span class="opening-hours__time">{{ day.label }}</span>
            </div>
        </div>
        <span class="opening-hours__next-week" :class="(maxDateHit ? 'opening-hours__next-week--disabled' : '')" @click="nextWeek()">
            <svgInline name="arrow" />
        </span>
    </div>
</template>

<script>
window.openingHoursLoaded = false;

import svgInline from '../components/svg-inline.vue';

export default {
    name: 'OpeningHoursView',
    components: {
        svgInline
    },
    data() {
        return {
            addDays: 0,
            lang: null,
            startDate: null,
            minDate: null,
            maxDate: null,
            minDateHit: null,
            maxDateHit: null,
            openingHourTypes: null,
            openingHourIntervals: null
        };
    },
    computed: {
        nextSevenDays() {
            const returnArray = [];

            if (this.openingHourTypes && this.openingHourIntervals) {
                const date = new Date();
                const currentDay = String(date.getDate()).padStart(2, '0');
                const currentMonth = String(date.getMonth()).padStart(2, '0');
                const currentYear = date.getFullYear();
                const currentDate = new Date(currentYear, currentMonth, currentDay);
                currentDate.setDate(currentDate.getDate() + this.addDays);

                for (let a = 1; a <= 7; a++) {
                    const nextDate = new Date(currentDate);
                    nextDate.setDate(nextDate.getDate() + a);
                    const nextDay = String(nextDate.getDate()).padStart(2, '0');
                    const nextDisplayMonth =  String(nextDate.getMonth() + 1).padStart(2, '0');
                    const nextMonth = String(nextDate.getMonth()).padStart(2, '0');
                    const nextYear = nextDate.getFullYear();
                    const openingHourObject = this.openingHourIntervals.filter(x => nextDate >= this.formatDate(x.OpeningHourInterval_StartDate) && nextDate <= this.formatDate(x.OpeningHourInterval_EndDate));
                    const openingHourTypeId = openingHourObject.length == 1 ? openingHourObject[0].OpeningHourInterval_Type : -1;
                    const openingHourType = this.openingHourTypes.filter(x => x.PageItemId == openingHourTypeId);
                    const openingHourLabel = openingHourType.length == 1 ? openingHourType[0].OpeningHourType_Name : '-';

                    returnArray.push({
                        jsDate: new Date(nextYear, nextMonth, nextDay),
                        date: `${nextDay}-${nextDisplayMonth}-${nextYear}`,
                        label: openingHourLabel
                    });
                }
            }

            const dates = returnArray.map(item => item.date);
            this.minDateHit = dates.includes(this.minDate);
            this.maxDateHit = dates.includes(this.maxDate);

            return returnArray;
        }
    },
    created() {
        const fetchUrl = '/api/content/feed/query?index=content&name=Opening%20hours&take=100';

        fetch(fetchUrl)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }

                return response.json();
            })
            .then(data => {
                if (data.QueryResult) {
                    this.openingHourTypes = data.QueryResult.filter(x => x.PageItemType == 'OpeningHourType');
                    this.openingHourIntervals = data.QueryResult.filter(x => x.PageItemType == 'OpeningHourInterval');

                    const startDates = this.openingHourIntervals.map(item => this.formatDate(item.OpeningHourInterval_StartDate));
                    const endDates = this.openingHourIntervals.map(item => this.formatDate(item.OpeningHourInterval_EndDate));
                    const minDate = new Date(Math.min(...startDates));
                    const maxDate = new Date(Math.max(...endDates));

                    const startDay = String(minDate.getDate()).padStart(2, '0');
                    const startMonth =  String(minDate.getMonth() + 1).padStart(2, '0');
                    const startYear = minDate.getFullYear();

                    const endDay = String(maxDate.getDate()).padStart(2, '0');
                    const endMonth =  String(maxDate.getMonth() + 1).padStart(2, '0');
                    const endYear = maxDate.getFullYear();

                    this.minDate = `${startDay}-${startMonth}-${startYear}`;
                    this.maxDate = `${endDay}-${endMonth}-${endYear}`;
                }
            })
            .catch(error => {
                console.error('Fetch error:', error);
            });
    },
    beforeUnmount() {

    },
    mounted() {
        this.lang = document.documentElement.lang;
        window.openingHoursLoaded = true;
    },
    methods: {
        formatDate(dateString) {
            const date = new Date(dateString);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth()).padStart(2, '0');
            const year = date.getFullYear();
            const returnDate = new Date(year, month, day);

            return returnDate;
        },
        getDayName(dateString) {
            return dateString.toLocaleDateString(document.documentElement.lang, { weekday: 'long' });
        },
        getDate(date) {
            return `${date.getDate()}.`;
        },
        getMonth(date) {
            return date.toLocaleDateString(document.documentElement.lang, { month: 'long' });
        },
        nextWeek() {
            this.addDays += 7;
        },
        prevWeek() {
            this.addDays -= 7;
        }
    }
};
</script>
